import Vue from 'vue'

export const eventbus = new Vue()


// WEBPACK FOOTER //
// ./src/eventbus.js